<div class="container-fluid">
    <div class="modal-header">
        <h5 class="modal-title headingValue">View Agenda</h5>
    </div>
    <div class="modal-body container">
        <div class="row">
            <div class="col-md-7">
                <div class="heading">
                    Section
                </div>
                <div class="subheadingValue">
                    {{agendaDetails?.sectionName}}
                </div>
            </div>
            <div class="col-md-3">
                <div class="heading">
                    Sub-Section
                </div>
                <div class="subheadingValue">
                    {{agendaDetails?.agendaSubSectionName}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="heading">
                    Agenda Subject
                </div>
                <div class="subheadingValue">
                    <p [innerHTML]="agendaDetails?.agendaItemSubject"></p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="heading">
                    Agenda Matter
                </div>
                <div class="subheadingValue">
                    <p [innerHTML]="agendaDetails?.agendaItemMatter"></p>
                </div>
            </div>
        </div>
    <span *ngIf="agendaDetails?.meetingStatusId === 39">        
        <hr>
        <div class="row">
            <div class="col-md-12">
                <div class="heading">
                    Recommendation by Sub Committee
                </div>
                <div class="subheadingValue">
                    <p [innerHTML]="agendaDetails?.agendaItemDiscussion"></p>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-md-12">
                <div class="heading">
                    Decision
                </div>
                <div class="subheadingValue">
                    <p [innerHTML]="agendaDetails?.agendaItemDecision"></p>
                </div>
            </div>
        </div>
        <hr>

        <div class="row">
            <div class="col-md-12">
                <b><label>Minutes Comment </label></b>
                <p [innerHTML]="agendaDetails?.minutesItemContent"></p>
            </div>
        </div>
    </span>

        <div *ngIf="agendaDetails?.agendaDocumentsList !=null">
        <div class="row" *ngIf="agendaDetails?.agendaDocumentsList?.length > 0">
            <div class="col-md-12">
                <h5 class="headingValue">Agenda Document</h5>
                <div *ngFor="let item of agendaDetails.agendaDocumentsList; let i=index">
                    <div class="iconCard">
                        <span><i class="far fa-file-alt docIcons"></i>{{item.name}}</span>
                        <a class="downloadView" (click)="viewDocuments(item.documentLocation, item.name)">
                            <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
 </div>

    </div>
</div>


            <!--ADDED BY GOKUL START VIEW COMMENT-->
            <hr style="color:black">
            <div class="col-md-12" *ngIf="agendaProcessHistoryList?.length!=0">
                <div id="accordion" class="myaccordion">
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <span class="headingValue">View Comments</span>
                            <h2 class="mb-0" style="float: right;">
                                <button *ngIf="CommentsPlusMinusFlag" (click)="commentsPlusMinusMethod('plus')"
                                    class="d-flex align-items-center justify-content-between btn btn-link"
                                    data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                    aria-controls="collapseOne">
                                    <span class="fa-stack fa-sm">
                                        <i class="fas fa-circle fa-stack-2x"></i>
                                        <i class="fas fa-plus fa-stack-1x fa-inverse"></i>
                                    </span>
                                </button>

                                <button *ngIf="!CommentsPlusMinusFlag" (click)="commentsPlusMinusMethod('minus')"
                                    class="d-flex align-items-center justify-content-between btn btn-link"
                                    data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                    aria-controls="collapseOne">
                                    <span class="fa-stack fa-sm">
                                        <i class="fas fa-circle fa-stack-2x"></i>
                                        <i class="fas fa-minus fa-stack-1x fa-inverse"></i>
                                    </span>
                                </button>
                            </h2>
                        </div>
                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div class="card-body">
                                <div class="col-md-12" *ngFor="let item  of agendaProcessHistoryList">
                                    <h5 class="headingValue">From</h5>
                                    &nbsp;<span>-</span>&nbsp;<span>{{item.whoAssignedUserId.fullName !== null ?
                                        item.whoAssignedUserId.fullName:'-'}}</span>
                                    &nbsp;<span class="badge badge-pill badge-success" style="color: white;">
                                        {{item.ecStatus?.statusName !==null ? item.ecStatus?.statusName :'-'}}
                                    </span>&nbsp;<span>{{item.createdDate !== null ? item.createdDate:'-'}}</span>
                                    <br>
                                    <h5 class="headingValue">To</h5>&nbsp;<span>-</span>&nbsp;
                                    <span> {{item.assignedToUserId.fullName !== null ?
                                        item.assignedToUserId.fullName:'-'}}</span>
                                    <span *ngIf="item.comments !='' && item.comments !=null"> <br /> </span>
                                    <h5 class="headingValue" *ngIf="item.comments !='' && item.comments !=null">Comment
                                    </h5>&nbsp;<span
                                        *ngIf="item.comments !='' && item.comments !=null">-</span>&nbsp;<span>{{item.comments
                                        !== "" ? item.comments:''}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--ADDED BY GOKUL ENDS VIEW COMMENT-->






